const uppercaseToNormalCase = string =>
	string
		.split('_')
		.join(' ')
		.toLowerCase()
		.replace(/^./, str => str.toUpperCase());

export default uppercaseToNormalCase;
